import ModalContext from 'contexts/ModalContext'
import type { ComponentProps } from 'react'
import { useCallback, useContext } from 'react'
import _LoyaltyPointsEarn from './_LoyaltyPointsEarn'
import LoyaltyPointsEarnBreakdownModal from './LoyaltyPointsEarnBreakdownModal'

type InheritedPriceRowLoyaltyPointsProps = Omit<ComponentProps<typeof _LoyaltyPointsEarn>, 'onInfoIconClick'>

interface Props extends InheritedPriceRowLoyaltyPointsProps {
  itemTitle?: string
  /**
   * Opt-in: show burn-adjusted (reduced) figures inside the breakdown modal so they match the
   * reduced inline earn. Currently enabled for tour only (LOYAL-2387); other surfaces keep showing
   * the full un-adjusted breakdown until they opt in.
   */
  showBurnAdjustedBreakdown?: boolean
}

function LoyaltyPointsEarnWithBreakdownModal({ itemTitle, calculationRequests, showBurnAdjustedBreakdown, ...rest }: Props) {
  const { pointsToApply, burnPriceInPoints } = rest
  const showModal = useContext(ModalContext)
  const handleInfoClick = useCallback(() => {
    showModal(<LoyaltyPointsEarnBreakdownModal
      calculationRequests={calculationRequests}
      itemTitle={itemTitle}
      pointsToApply={showBurnAdjustedBreakdown ? pointsToApply : undefined}
      burnPriceInPoints={showBurnAdjustedBreakdown ? burnPriceInPoints : undefined}
    />)
  }, [showModal, calculationRequests, itemTitle, showBurnAdjustedBreakdown, pointsToApply, burnPriceInPoints])

  return <_LoyaltyPointsEarn {...rest} calculationRequests={calculationRequests} onInfoIconClick={handleInfoClick} />
}

export default LoyaltyPointsEarnWithBreakdownModal
